import { finalize, first,switchMap,  takeUntil } from "rxjs/operators";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Currency } from "./currency";
import { Account, ClientData, PortfolioElement, Profile } from "./client-data";
import { AccountService } from "./../../services/account.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Bank } from "./bank";
import Swal from "sweetalert2";
import { NgForm } from "@angular/forms";
import { MarginCalculatorComponent } from "src/app/components/margin-calculator/margin-calculator.component";
import { DatePipe } from "@angular/common";
import { UrlConstants } from "src/app/models/urlConstants";
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ChartComponent,
  ApexTheme,
} from "ng-apexcharts";
import { ApiService } from "src/app/services/api.service";
import { InputCommaSepreatedPipe } from "src/app/services/input-comma-sepreated.pipe";
import * as moment from "moment";
import {
  SignalRConfiguration,
  BroadcastEventListener,
  SignalR,
  ISignalRConnection,
} from "ng2-signalr";
import { Subject,of } from "rxjs";
import { SystemSettingsService } from "src/app/services/systemSettings.service";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  theme: ApexTheme;
};
export class FileToUpload {
  fileName: string = "";
  fileSize: number = 0;
  fileType: string = "";
  fileAsBase64: string = "";
}

interface DepositRequest {
  CurrencyId: number;
  Date: String;
  RelationCode: string;
  Amount: number;
  DepositeBankId: number;
  file: FileToUpload;
}
interface StockRequest {
  SymbolCode: string;
  RelationCode: string;
  Qty: number;
  CustodianCode: number;
  CostPrice: number;
}
interface T0Request {
  RelationCode: string;
  Body: string;
}
interface WithdrawRequest {
  CurrencyId: number;
  Date: String;
  RelationCode: string;
  Amount: number;
  ActionType: number;
  BankId: number;
  BankBrachId: number;
  SwiftCode: string;
  AccountNumber: string;
  Note: string;
}

interface ComplainRequest {
  Body: string;
  ActionType: number;
  DepartmentId: number;
  RelationCode: string;
}
interface CashTransferRequest {
  Date: String;
  FromRelationCode: string;
  IpAddress: string;
  ToRelationCode: string;
  CurrencyId: number;
  Amount: number;
  IsPost: boolean;
}
export interface TransferResponse {
  isValid?: boolean;
  errors?: string[];
  ErrorMessage?: string;
  JournalSerial?: string | null;
  JournalID?: number;
}

interface StockTransferRequest {
  FromRelationCode: string;
  ToRelationCode: string;
  Symbol: PortfolioElement;
  Qty: number;
}

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit {
  @ViewChild("CashTransaction") cashTransactionForm: NgForm;
  @ViewChild("StockTransaction") stockTransactionForm: NgForm;
  @ViewChild("payableForm") payableForm: NgForm;
  @ViewChild("withdrawForm") withdrawForm: NgForm;
  @ViewChild("reqStockForm") reqStockForm: NgForm;
  @ViewChild("reqT0Form") reqT0Form: NgForm;
  @ViewChild("suggestionForm") suggestionForm: NgForm;
  @ViewChild("complainForm") complainForm: NgForm;

  userPortfolio: ClientData;
  isProfileLoading = false;
  accList: any = [];

  selectedStockTransferAcc;
  newDeposit: DepositRequest = {} as DepositRequest;
  newWithdraw: WithdrawRequest = {} as WithdrawRequest;
  newReqStock: StockRequest = {} as StockRequest;
  newReqT0: T0Request = {} as T0Request;
  newComplain: ComplainRequest = {} as ComplainRequest;
  newCashTransfer: CashTransferRequest = {} as CashTransferRequest;
  newStockTransfer: StockTransferRequest = {} as StockTransferRequest;
  isDarkTheme: boolean;
  isProfileUpdating = false;
  fileToUpload: File | null = null;
  fileName: string;
  companyName: string;
  purchasePowerRes: any;

  date = new Date();
  today = new Date();
  banksList: Bank[] = [];
  currencyList: Currency[] = [];
  deptList;
  isSubmitting = false;
  submitStatus;
  userInvoice: Object;
  selectedAccount;
  selectedCurr = "EGP";
  Endorsement: string;
  clientStockProfile: any[];
  stockAccObj;
  toAccList: any;
  toStockAccList: any;
  allstocks: any;
  allCustod: any;
  stocksSymbolList: any;
  stocksCustodiansList: any;
  textConfirmMassage;
  showTradesSummary: boolean = false;

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  chartStocks: number;
  purchaseStocks: number;
  titleMessage: string;
  branches: any;
  balanceAmount: any;
  noChart: boolean;
  userName: string;
  lastLogin: string;
  loading: boolean;
  private destroy$ = new Subject<void>();
  ppDetailsShown: boolean = false;

  private portfolioConnection: ISignalRConnection;
  selectedAccountType: any;

  constructor(
    private http: HttpClient,
    private accService: AccountService,
    public translate: TranslateService,
    public datepipe: DatePipe,
    private router: Router,
    private dialog: MatDialog,
    private formatPipe: InputCommaSepreatedPipe,
    private apiService: ApiService,
    private signalR: SignalR,
    private cdr: ChangeDetectorRef,
    private systemSetting: SystemSettingsService

  ) {
    
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
    this.selectedAccount = this.accList[0].relationCode;
    const selectedAccountObj = this.accList.find(acc => acc.relationCode === this.selectedAccount);
    this.selectedAccountType = selectedAccountObj ? selectedAccountObj.accountType : null;
    this.fetchUserPortfolio();
    // this.initPortfolioSignalR();
  }

  get isMarginCust() {
    if (this.accList.length > 0)
      return this.accList.find(
        (acc) => acc.relationCode == this.selectedAccount
      ).accountType;
  }

  importFile(files) {
    const maxAllowedSize = 5 * 1024 * 1024;

    if (maxAllowedSize > files[0].size) {
      this.fileToUpload = files[0];
      this.fileName = this.fileToUpload.name;
    } else {
      this.fileName = this.translate.instant("too-big");
    }
  }

  initPortfolioSignalR() {
    let config: SignalRConfiguration = new SignalRConfiguration();
    config.url = UrlConstants.backofficeUrl;
    config.hubName = "ordersHub";
    config.logging = false;

    let exchangeCode = this.accList.find(
      (item) => item.relationCode == this.selectedAccount
    ).ExchangeCode;

    const selectedAccountObj = this.accList.find(acc => acc.relationCode === this.selectedAccount);
    this.selectedAccountType = selectedAccountObj ? selectedAccountObj.accountType : null;
    this.signalR.connect(config).then((res) => {
      this.portfolioConnection = res;

      this.portfolioConnection.invoke("JoinGroup", exchangeCode);

      let method = new BroadcastEventListener<any>("UpdatePortfolio");

      this.portfolioConnection.listen(method);
      method.subscribe((update) => {
        this.fetchUserPortfolio();
      });

      this.portfolioConnection.errors.subscribe((res) => {
        this.initPortfolioSignalR();
      });
    });
  }

  submitDeposit(form: NgForm) {
    this.newDeposit.Amount = form.form.value.Amount;
    this.newDeposit.Date = new Date().toLocaleString("en-us", {
      timeZone: "Africa/Cairo",
    });
    this.newDeposit.RelationCode = form.form.value.RelationCode;
    this.newDeposit.CurrencyId = form.form.value.CurrencyId.CurrencyID;
    this.newDeposit.DepositeBankId = form.form.value.DepositeBankId.BankID;

    this.isSubmitting = true;

    if (this.fileToUpload != null) {
      let file = new FileToUpload();
      // Set File Information
      file.fileName = this.fileToUpload.name;
      file.fileSize = this.fileToUpload.size;
      file.fileType = this.fileToUpload.type;
      // Use FileReader() object to get file to upload
      // NOTE: FileReader only works with newer browsers
      let reader = new FileReader();
      // Setup onload event for reader
      reader.onload = () => {
        // Store base64 encoded representation of file
        file.fileAsBase64 = reader.result.toString();
        this.newDeposit.file = file;
        this.postDepositeToServer(form);
      };
      // Read the file
      reader.readAsDataURL(this.fileToUpload);
    } else {
      this.postDepositeToServer(form);
    }
  }

  postDepositeToServer(form: NgForm) {
    if (this.translate.currentLang == "ar") {
      this.titleMessage = "تأكيد طلب ايداع";
      this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
   الحساب: ${form.form.value.RelationCode}  العملة: ${form.form.value.CurrencyId.AbbreviationA
        }
   التاريخ: ${this.datepipe.transform(
          this.newDeposit.Date.toString(),
          "dd-MM-yyyy"
        )}    المبلغ المودع: ${form.form.value.Amount}
   بنك الايداع:  ${form.form.value.DepositeBankId.BankNameA}`;
    }
    if (this.translate.currentLang == "en") {
      this.titleMessage = "Deposite Request Confirmation";
      this.textConfirmMassage = `Please check the information before sending the request
  Account: ${form.form.value.RelationCode} Currency: ${form.form.value.AbbreviationE
        }
  Amount: ${form.form.value.Amount} Select Date: ${this.datepipe.transform(
          this.newDeposit.Date.toString(),
          "dd-MM-yyyy"
        )}
  Deposit Bank: ${form.form.value.DepositeBankId.BankNameE}`;
    }

    Swal.fire({
      title: this.titleMessage,
      html: "<pre>" + this.textConfirmMassage + "<pre>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: this.translate.instant("yes"),
      cancelButtonText: this.translate.instant("no"),
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .post(
            UrlConstants.backofficeUrl +
            "/api/OnlineTrading/PostPayableRequest",
            this.newDeposit
          )
          .subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              this.payableForm.resetForm();
              this.fileName = null;
              this.fileToUpload = null;
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            }
          );
      } else if (
        /* Read more about handling dismissals below */
        !result.isConfirmed
      ) {
        this.isSubmitting = false;
      }
    });
  }
  submitWithdraw(form: NgForm) {
    this.isSubmitting = true;
    this.newWithdraw.Date = new Date().toLocaleString("en-us", {
      timeZone: "Africa/Cairo",
    });
    if (this.newWithdraw.ActionType == 1) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد طلب سحب";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
     الحساب: ${form.form.value.client}  العملة: ${form.form.value.CurrencyId.AbbreviationA
          }
     التاريخ: ${this.datepipe.transform(
            this.newWithdraw.Date.toString(),
            "dd-MM-yyyy"
          )}    المبلغ المسحوب: ${form.form.value.Amount}
     نوع التحويل:  شيك`;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Withdraw Request Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
    Account: ${form.form.value.RelationCode} Currency: ${form.form.value.CurrencyId.AbbreviationE
          }
    Amount: ${form.form.value.Amount} Select Date: ${this.datepipe.transform(
            this.newWithdraw.Date.toString(),
            "dd-MM-yyyy"
          )}
    Transaction Type: Chech Deposite`;
      }
    }
    if (this.newWithdraw.ActionType == 2) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد طلب سحب";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
     الحساب: ${form.form.value.client}  العملة: ${form.form.value.CurrencyId.AbbreviationA
          }
     التاريخ: ${this.datepipe.transform(
            this.newWithdraw.Date.toString(),
            "dd-MM-yyyy"
          )}    المبلغ المسحوب: ${form.form.value.Amount}
     نوع التحويل:  تحويل بنكي
     بنك الايداع:  ${form.form.value.depositBank.BankNameA}
     فرع البنك: ${form.form.value.bankBranch.BankNameA}
    رقم الحساب:  ${form.form.value.AccountNumber}
      ${form.form.value.SwiftCode} :IBAN
    `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Withdraw Request Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
    Account: ${form.form.value.RelationCode} Currency: ${form.form.value.CurrencyId.AbbreviationE
          }
    Amount: ${form.form.value.Amount} Select Date: ${this.datepipe.transform(
            this.newWithdraw.Date.toString(),
            "dd-MM-yyyy"
          )}
    Transaction Type: Bank Transfer Deposit
    Deposite Bank: ${form.form.value.depositBank.BankNameE}
    Bank Branch: ${form.form.value.bankBranch.BankNameE}
    Account Number: ${form.form.value.AccountNumber}
    IBAN: ${form.form.value.SwiftCode}
          `;
      }

      this.newWithdraw.BankId = form.form.value.depositBank.BankID;
      this.newWithdraw.BankBrachId = form.form.value.bankBranch.BranchID;
    }
    

    this.newWithdraw.CurrencyId = form.form.value.CurrencyId.CurrencyID;
    this.newWithdraw.Note= form.form.value.Note;
    Swal.fire({
      title: this.titleMessage,
      html: "<pre>" + this.textConfirmMassage + "<pre>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: this.translate.instant("yes"),
      cancelButtonText: this.translate.instant("no"),
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .post(
            UrlConstants.backofficeUrl +
            "/api/OnlineTrading/PostReceivableRequest",
            this.newWithdraw
          )
          .subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();

              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              }).then(() => {
                this.router.navigate(["/home"]);
              });
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            }
          );
      } else if (
        /* Read more about handling dismissals below */
        !result.isConfirmed
      ) {
        this.isSubmitting = false;
      }
    });
  }

  generateInvoice() {
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Invoice/getClientInvoice?fromDate=01-03-2020&toDate=01-03-2021&lang=1&relationCode=${this.selectedAccount}`
      )
      .subscribe((res) => {
        this.userInvoice = res;
        this.router.navigate(["invoice"], {
          state: { invoice: this.userInvoice },
        });
      });
  }

  fetchUserPortfolio(selectedAcc?) {
    this.showTradesSummary = true;
    if (selectedAcc) this.selectedAccount = selectedAcc;
    this.initPortfolioSignalR();
    this.noChart = null;
    this.isProfileLoading = true;

    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${this.selectedAccount}`
      )
      .pipe(
    takeUntil(this.destroy$),
    finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    })
  )
      .subscribe((res) => {
        this.isProfileLoading = false;
        this.userPortfolio = res as ClientData;

        this.companyName = this.userPortfolio.Profile.CompanyNameAr;

        this.Endorsement = `الساده شركة ${this.companyName} برجاء التكرم بفتح حد إئتمان للتداول في ذات الجلسة علي حسابي طرف شركتكم  وفي حالة التنفيذ و ظهور مديونية أتعهد أن يتم سداد كامل مديونية اليوم بالبيع أو بالإيداع و في حالة عدم التزامي بإغلاق المديونية قبل نهاية الجلسة بنصف ساعة أفوض الشركة ببيع أي أسهم موجودة بمحفظتي لسداد كامل المديونية وهذا إقرار مني بذلك`;
this.updateCustodianSymbolMargins(selectedAcc);
        if (
          this.ratedActiveBalance == 0 &&
          this.userPortfolio.Portfolio.RatedPortfolio == null
        )
          this.noChart = true;
        else if (
          this.ratedActiveBalance > 0 &&
          (!this.userPortfolio.Portfolio?.RatedPortfolio ||
            this.userPortfolio.Portfolio?.RatedPortfolio?.TotalMarketValue == 0)
        ) {
          this.purchaseStocks = 100;
          this.chartStocks = 0;
          this.initChart();
        } else if (
          this.ratedActiveBalance <= 0 &&
          this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue > 0
        ) {
          this.purchaseStocks = 0;
          this.chartStocks = 100;
          this.initChart();
        } else {
          this.chartStocks =
            parseFloat(((this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue /
              (this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue +
                this.ratedActiveBalance)) *
            100).toFixed(2));
          this.purchaseStocks =
            parseFloat(((this.ratedActiveBalance /
              (this.userPortfolio?.Portfolio?.RatedPortfolio?.TotalMarketValue +
                this.ratedActiveBalance)) *
            100).toFixed(2));
          this.initChart();
        }
        // if (this.userPortfolio.Portfolio.RatedPortfolio) {
        //   this.chartStocks =
        //     (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue /
        //       (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
        //         this.ratedActiveBalance)) *
        //     100;
        //   this.purchaseStocks =
        //     (this.ratedActiveBalance /
        //       (this.userPortfolio.Portfolio.RatedPortfolio.TotalMarketValue +
        //         this.ratedActiveBalance)) *
        //     100;
        //   this.initChart();
        // } else if (this.ratedActiveBalance) {
        //   this.purchaseStocks = 100;
        //   this.chartStocks = 0;
        //   this.initChart();
        // }
      });
  }

  get ratedBookBalance() {
    return this.userPortfolio?.PurchasePower?.BlockingAmount?.find(
      (value) => value.curr == "Rated"
    );
  }

  get currenciedBookBalance() {
    return this.userPortfolio?.PurchasePower?.BlockingAmount?.find(
      (value) => value.curr == this.selectedCurr
    );
  }

  get currenciedPortfolio() {
    switch (this.selectedCurr) {
      case "EGP":
        return this.userPortfolio?.Portfolio.EGPPortfolio;
      case "Rated":
        return this.userPortfolio?.Portfolio.RatedPortfolio;
      case "USD":
        return this.userPortfolio?.Portfolio.USDPortfolio;
    }
  }
      get GoalCurrenciedPortfolio() {
    if (this.userPortfolio?.Portfolio != null)
      switch (this.selectedCurr) {
        case "EGP":
          return this.userPortfolio?.Portfolio.EGPPortfolio;
        case "Rated":
          return this.userPortfolio?.Portfolio.RatedPortfolio;
        case "USD":
          return this.userPortfolio?.Portfolio.USDPortfolio;
      }
  }
  get ratedActiveBalance() {
    return this.userPortfolio?.PurchasePower?.BlockingAmount?.find(
      (item) => item.curr == "Rated"
    ).activebalance;
  }

  get currenciedPP() {
    try {
      return this.userPortfolio.PurchasePower.purchasePower[this.selectedCurr];
    } catch (error) { }
  }

  initChart() {
    this.chartOptions = {
      series: [this.chartStocks, this.purchaseStocks],
      chart: {
        width: "100%",
        height: "295",
        type: "donut",
      },
      theme: {
        mode: "light",
        palette: "palette7",
      },
      labels: [
        this.translate.instant("stocks"),
        this.translate.instant("cash"),
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    };
  }

  get bookBalance() {
    return this.userPortfolio.PurchasePower.BlockingAmount.find(
      (value) => value.curr == this.selectedCurr
    );
  }

  get blockAmount() {
    return (
      this.bookBalance?.blkAmt +
      this.bookBalance?.pendBuy +
      this.bookBalance?.withHeldAmt +
      this.bookBalance?.penSellCommission
    );
  }

  submitComplain(form: NgForm, isComplain) {
    this.isSubmitting = true;

    if (isComplain) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد طلب شكوى";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
  :الادارة التي يخصها الشكوى
  ${form.form.value.DepartmentId.DepartmentNameA}
  :الشكوى
  `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Complain Request Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
 department: ${form.form.value.DepartmentId.DepartmentNameE}
 complain :`;
      }
      this.newComplain.ActionType = 1;
      this.newComplain.RelationCode = this.selectedAccount;
      this.newComplain.Body = form.form.value.Body;
      this.newComplain.DepartmentId = form.form.value.DepartmentId.DepartmentID;

      Swal.fire({
        title: this.titleMessage,
        html:
          "<pre>" +
          this.textConfirmMassage +
          "</pre><p>" +
          form.form.value.Body +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .post(
              UrlConstants.backofficeUrl +
              "/api/OnlineTrading/PostActionRequest",
              this.newComplain
            )
            .subscribe(
              (res) => {
                this.isSubmitting = false;
                if (res) this.submitStatus = res;
                form.resetForm();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("succes-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              },
              (err) => {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("error-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    } else {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد طلب اقتراح";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
        :الاقتراح
      `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Suggestion Request Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
     suggestion :
     `;
      }
      this.newComplain.ActionType = 2;
      this.newComplain.RelationCode = this.selectedAccount;
      this.newComplain.Body = form.form.value.Body;

      Swal.fire({
        title: this.titleMessage,
        html:
          "<pre>" +
          this.textConfirmMassage +
          "</pre><p>" +
          form.form.value.Body +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .post(
              UrlConstants.backofficeUrl +
              "/api/OnlineTrading/PostActionRequest",
              this.newComplain
            )
            .subscribe(
              (res) => {
                this.isSubmitting = false;
                if (res) this.submitStatus = res;
                form.resetForm();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("succes-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              },
              (err) => {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("error-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
  }
  // fetchUserProfile() {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //       Authorization: this.accService.userValue.toString(),
  //     }),
  //   };

  //   this.http
  //     .get(
  //       `${UrlConstants.backofficeUrl}/api/Client/GetClientProfile?relationCode=1001-1`,
  //       httpOptions
  //     )
  //     .subscribe((res) => {
  //       this.userInfo = res;
  //     });
  // }
  GetBranches(e) {
    this.branches = e.BankBranches;
  }

  ngOnInit(): void {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
    this.fetchBanks();
    this.fetchActiveCurrencies();
    // this.getClientStockPortofolio();
    this.fetchDepartment();
    // this.newDeposit.Date = this.newWithdraw.Date = this.today;
    this.userName = sessionStorage.getItem("userName");
    this.lastLogin = JSON.parse(
      localStorage.getItem("userProfile")
    ).LastSuccessLoginTime;
    // this.newWithdraw.ActionType =1;
    this.fetchSelectedCurr()

  }
  commaSeprated(event) {
    let input = event.target as HTMLInputElement;
    let number = parseFloat(input.value);
    input.value = this.formatPipe.transform(number).toString();
  }
  fetchPurchasePower(relCode) {
    if (relCode != null) {
      this.apiService.fetchPurchasePower(relCode).subscribe((arg) => {
        this.purchasePowerRes = arg;

        this.balanceAmount = this.purchasePowerRes.BlockingAmount;
      });
    }

  }

  get availableWithdrawBalance() {
    if (this.withdrawForm != null) {
      if (this.withdrawForm?.form?.get("CurrencyId")?.value != null) {
        if (
          this.balanceAmount &&
          this.withdrawForm?.form?.get("CurrencyId")?.value["AbbreviationE"]
        ) {
          var x = this.balanceAmount.find(
            (x) =>
              x.curr ==
              this.withdrawForm.form.get("CurrencyId").value["AbbreviationE"]
          );
          if (x) return x["AvailableBalanceForWithdrow"];
          else return 0;
        }
      }
    }
  }

  availableTransferBalance(form) {
    if (form.form.get("Currency")?.value != null) {
      if (
        this.balanceAmount &&
        form.form.get("Currency")?.value["AbbreviationE"] != null
      ) {
        var x = this.balanceAmount.find(
          (item) => item.curr == form.form.get("Currency").value["AbbreviationE"]
        );

        if (x) return x["availablebalancefortransfer"];
        else return 0;
      }
    }
  }

  fetchBanks() {
    this.http
      .get(`${UrlConstants.backofficeUrl}/api/Settings/GetBanks`)
      .pipe(
    takeUntil(this.destroy$),
    finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    })
  )
      .subscribe((res) => {
        this.banksList = res as Bank[];
      });
  }
  fetchActiveCurrencies() {
    return this.http.get(
      `${UrlConstants.backofficeUrl}/api/Settings/GetActiveCurrencies`
    )
    .pipe(
    takeUntil(this.destroy$),
    finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    })
  )
    .subscribe((res) => {

      this.currencyList = res as Currency[];
    });
  }

  //SAMY
  noDecimal(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  submitStockTransfer(form: NgForm) {
    if (form && form.valid) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد تحويل اسهم";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال التحويل
        من الحساب: ${form.form.value.FromAccountStock} الى الحساب: ${form.form.value.ToRelationCode}
        امين حفظ: ${this.newStockTransfer.Symbol.CustodianNameA}
        كمية: ${form.form.value.Quantity}
        السهم: ${this.newStockTransfer.Symbol.SymbolNameAr}`;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Stock Transfer Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
   From Account: ${form.form.value.FromAccountStock} To Account: ${form.form.value.ToRelationCode}
   Stock: ${this.newStockTransfer.Symbol.SymbolNameEn}
   Custodian: ${this.newStockTransfer.Symbol.CustodianNameE}
   Quantity: ${form.form.value.Quantity}`;
      }

      let request = {
        FromRelationCode: form.form.value.FromAccountStock,
        ToRelationCode: form.form.value.ToRelationCode,
        SymbolCode: form.form.value.SymbolCode.SymbolCode,
        CustodianCode: form.form.value.SymbolCode.CustodianCode,
        Qty: form.form.value.Quantity,
      };

      Swal.fire({
        title: this.titleMessage,
        html: "<pre>" + this.textConfirmMassage + "</pre>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .post(
              UrlConstants.backofficeUrl + "/api/Journal/TransferClientStocks",
              request
            )
            .subscribe((res) => {
              this.submitStatus = res;
              if (res["errors"] == null) {
                this.isSubmitting = false;
                form.resetForm();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("succes-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              } else {
                this.isSubmitting = false;
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant(res["errors"][0]),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            });
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
  }

submitCashTransfer(form: NgForm) {
  this.isSubmitting = true;
  let latest_date = this.datepipe.transform(this.date, "YYYY-MM-dd");

  this.newCashTransfer.Date = latest_date;
  this.newCashTransfer.IpAddress = "";
  this.newCashTransfer.IsPost = true;

  if (form && form.valid) {
    // Build confirmation message in the current language
    if (this.translate.currentLang == "ar") {
      this.titleMessage = "تأكيد تحويل نقدي";
      this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
     من الحساب: ${form.form.value.FromAccount} الى الحساب: ${form.form.value.ToAccount}
     مبلغ: ${form.form.value.Amount} العملة: ${form.form.value.Currency.AbbreviationA}`;
    }
    if (this.translate.currentLang == "en") {
      this.titleMessage = "Cash transfer Confirmation";
      this.textConfirmMassage = `Please check the information before sending the request
      From Account: ${form.form.value.FromAccount} To Account: ${form.form.value.ToAccount}
     Amount: ${form.form.value.Amount} Currency: ${form.form.value.Currency.AbbreviationE}`;
    }
    this.newCashTransfer.CurrencyId = form.form.value.Currency.CurrencyID;

    Swal.fire({
      title: this.titleMessage,
      html: "<pre>" + this.textConfirmMassage + "<pre>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: this.translate.instant("yes"),
      cancelButtonText: this.translate.instant("no"),
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.http
          .post(
            UrlConstants.backofficeUrl + "/api/Journal/TransferClientJournal",
            this.newCashTransfer
          )
          .subscribe(
            (res: any) => {  // Use 'any' or define TransferResponse interface
              this.isSubmitting = false;

              if (res.isValid == true) {
                // Success
                form.resetForm();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("succes-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                }).then(() => {
                  this.router.navigate(["/home"]);
                });
              } else {
                // Error response with validation codes or message
                let errorMsg: string;
                if (res.ErrorMessage) {
                  errorMsg = this.translate.instant(res.ErrorMessage);
                } else if (res.journalValidations && res.journalValidations.length) {
                  const code = res.journalValidations[0]; // show first error
                  const key = this.validationMessageKeys[code];
                  errorMsg = key ? this.translate.instant(key) : this.translate.instant("error-msg");
                } else {
                  errorMsg = this.translate.instant("error-msg");
                }

                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: errorMsg,
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            },
            (err) => {
              this.isSubmitting = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            }
          );
      } else {
        // User cancelled confirmation
        this.isSubmitting = false;
      }
    });
  } else {
    // Form invalid – you might want to show a message or just reset submitting flag
    this.isSubmitting = false;
  }
}
private validationMessageKeys: { [code: number]: string } = {
  1: 'error.clientBalance',
  2: 'error.journalDate',
  3: 'error.notHaveTradingInfo',
  4: 'error.transferToAnotherClient',
  5: 'error.amountMoreThanZero',
  6: 'error.marginCustodianRestriction',
  7: 'error.duplicateQueueId'
};
  submitReqStock(form: NgForm) {
    this.isSubmitting = true;
    if (form && form.valid) {
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد طلب حجز اسهم";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
     الحساب: ${form.form.value.RelationCode}     كمية: ${form.form.value.Qty}
    امين حفظ: ${form.form.value.CustodianCode.CustodianNameA}
    السهم:  ${form.form.value.SymbolCode.ShortNameA}
  سعر التكلفة: ${form.form.value.CostPrice}`;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "Book Stock Request Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
       Account: ${form.form.value.RelationCode}   Qty: ${form.form.value.Qty}
       Custodian: ${form.form.value.CustodianCode.CustodianNameE}
      Stock: ${form.form.value.SymbolCode.ShortNameE}
    Cost Price: ${form.form.value.CostPrice}`;
      }
      this.newReqStock.RelationCode = form.form.value.RelationCode;
      this.newReqStock.Qty = form.form.value.Qty;
      this.newReqStock.CustodianCode =
        form.form.value.CustodianCode.CustodianCode;
      this.newReqStock.SymbolCode = form.form.value.SymbolCode.SymbolCode;
      this.newReqStock.CostPrice = form.form.value.CostPrice;
      Swal.fire({
        title: this.titleMessage,
        html: "<pre>" + this.textConfirmMassage + "<pre>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.http
            .post(
              UrlConstants.backofficeUrl +
              "/api/OnlineTrading/PostRequestStockBook",
              this.newReqStock
            )
            .subscribe(
              (res) => {
                this.isSubmitting = false;
                if (res) this.submitStatus = res;
                form.resetForm();
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: this.translate.instant("succes-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              },
              (err) => {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: this.translate.instant("error-msg"),
                  showConfirmButton: false,
                  timer: 4500,
                });
              }
            );
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
  }
  submitReqT0(form: NgForm) {
    if (form && form.valid) {
      this.newReqT0.RelationCode = form.form.value.RelationCode;
      this.newReqT0.Body = this.Endorsement;
      if (this.translate.currentLang == "ar") {
        this.titleMessage = "تأكيد طلب (T+0)";
        this.textConfirmMassage = `برجاء مراجعه البيانات التالية قبل ارسال الطلب
      الحساب: ${form.form.value.RelationCode}
      الشكوى:
      `;
      }
      if (this.translate.currentLang == "en") {
        this.titleMessage = "T+0 Request Confirmation";
        this.textConfirmMassage = `Please check the information before sending the request
     Account: ${form.form.value.RelationCode}`;
      }
      Swal.fire({
        title: this.titleMessage,
        html:
          "<pre>" +
          this.textConfirmMassage +
          "</pre><p>" +
          form.form.value.Body +
          "</p>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("yes"),
        cancelButtonText: this.translate.instant("no"),
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.fetchTPlusZero(this.newReqT0).subscribe(
            (res) => {
              this.isSubmitting = false;
              if (res) this.submitStatus = res;
              form.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: this.translate.instant("succes-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            },
            (err) => {
              Swal.fire({
                position: "center",
                icon: "error",
                title: this.translate.instant("error-msg"),
                showConfirmButton: false,
                timer: 4500,
              });
            }
          );
        } else if (
          /* Read more about handling dismissals below */
          !result.isConfirmed
        ) {
          this.isSubmitting = false;
        }
      });
    }
  }
  accountListValidation(e) {
    if (this.accList) {
      let temp = this.accList.filter((c) => c.relationCode != e);
      this.toAccList = [...temp];
    }
  }

  stockTransferChanged(e) {
    this.newStockTransfer.Qty = e.SetteledQty;
  }

  accountStockListValidation(client) {
    this.newStockTransfer.Symbol = null;
    this.newStockTransfer.Qty = null;
    this.newStockTransfer.ToRelationCode = null;
    // this.newStockTransfer.FromRelationCode = client.relationCode;
    let selectedAccFrom = this.accList.find((item) => {
      return item.relationCode == client;
    });
    this.http
      .get(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${client}`
      )
      .pipe(
    takeUntil(this.destroy$),
    finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    })
  )
      .subscribe((res: ClientData) => {
        this.stocksSymbolList = res?.Portfolio?.RatedPortfolio?.Portfolio?.sort(
          (a, b) => a.SymbolNameAr.localeCompare(b.SymbolNameAr)
        );
      });
    if (this.accList) {
      let temp = this.accList.filter((x) => {
        return (
          x.accountType !==3 && x.accountType !==5 &&
          x.SubCode == selectedAccFrom.SubCode &&
          x.relationCode != selectedAccFrom.relationCode
        );
      });

      this.toStockAccList = [...temp];

      // this.stocksCustodiansList = this.clientStockProfile.filter(
      //   (x) => x.Profile.RelationCode == e
      // )[0].Custodians;
      // this.stocksSymbolList = this.clientStockProfile.filter(
      //   (x) => x.Profile.RelationCode == e
      // )[0].Symbols;
    }
  }
  fetchSymbolsandCustd() {
    this.apiService
      .fetchBOAllSymbols()
      .pipe(
    takeUntil(this.destroy$),
    finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    })
  )
      .subscribe((res) => (this.allstocks = res));
    this.apiService.fetchAllCustd().subscribe((arg) => (this.allCustod = arg));
  }
  fetchDepartment() {
    this.apiService
      .fetchDepartments()
      .pipe(
    takeUntil(this.destroy$),
    finalize(() => {
      this.loading = false;
      this.cdr.detectChanges();
    })
  )
      .subscribe((res) => (this.deptList = res));
  }

  // getClientStockPortofolio() {
  //   this.http
  //     .get(
  //       `${UrlConstants.backofficeUrl}/api/Journal/getClientAccountsPortfolioDetails`
  //     )
  //     .subscribe((res) => {
  //       this.clientStockProfile = res as any[];
  //     });
  // }
  resetForm() {
    this.fileName = null;
    this.payableForm.resetForm();
  }

  get marginPercent() {
    if (
      this.userPortfolio?.PurchasePower["MarginPosition"]
        .UsedMarginPersentage != null
    )
      return this.userPortfolio?.PurchasePower["MarginPosition"]
        .UsedMarginPersentage;
  }

  get chartColor() {
    if (this.marginPercent < 50) {
      return "#2E94D3";
    }
    if (this.marginPercent >= 50 && this.marginPercent < 61) {
      return "#28A745";
    }
    if (this.marginPercent > 60 && this.marginPercent < 70) {
      return "#2eced3";
    }
    if (this.marginPercent >= 70) {
      return "#d33e2e";
    }
  }

  marginCalculator() {
    const dialogRef = this.dialog.open(MarginCalculatorComponent, {
      panelClass: "order-dialog-container",
      data: { relationCode: this.selectedAccount },
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
  depositeConfirmation() {
    this.payableForm.form.value.CurrencyId =
      this.payableForm.form.value.CurrencyId.CurrencyID;
    this.payableForm.form.value.DepositeBankId =
      this.payableForm.form.value.DepositeBankId.BankID;
  }
  bankDepositeChange() {
    if (this.translate.currentLang == "ar") {
    }
    if (this.translate.currentLang == "en") {
    }
  }

  hideTradesSummary() {
    this.showTradesSummary = false;
  }

  onReset(form) {
    form.reset();
    this.balanceAmount = null;
  }
  ngOnDestroy(): void {
    if (this.portfolioConnection != null) this.portfolioConnection.stop();


    this.destroy$.next();
    this.destroy$.complete();
  }
  fetchSelectedCurr(){
this.systemSetting.checkDefaultCurr('Default Currency Client Profile').subscribe((res) => {
  if (res) {
    if(res.value=='1') {
      this.selectedCurr = "EGP";
    }
    else if(res.value=='2') {
      this.selectedCurr = "Rated";
    }
    else{
      this.selectedCurr = "USD";
    }
  }
});
}
private updateCustodianSymbolMargins(selectedAcc: Account): void {
    if (!selectedAcc || !this.userPortfolio?.Portfolio) {
      return;
    }

    this.isProfileLoading = true;
    this.cdr.detectChanges();
    
    this.apiService.getCustodianByRelationCode(selectedAcc)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((custodianRes: any) => {
          const marginCustodianId = custodianRes?.CustodianCode ?? -1;
          if (marginCustodianId === -1) {
            return of(null);
          }
          const filter = { CustodianCode: marginCustodianId };
            return this.accService.GetCustodianSymbols(filter);
        }),
        finalize(() => {
          this.isProfileLoading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (custodianSymbols) => {
          if (!custodianSymbols || custodianSymbols.length === 0) {
            return;
          }

          if (this.userPortfolio.Portfolio.EGPPortfolio?.Portfolio) {
            const updatedArray = this.updatePortfolioMargins(
              this.userPortfolio.Portfolio.EGPPortfolio.Portfolio,
              custodianSymbols
            );
            this.userPortfolio.Portfolio.EGPPortfolio = {
              ...this.userPortfolio.Portfolio.EGPPortfolio,
              Portfolio: updatedArray
            };
          }

          if (this.userPortfolio.Portfolio.USDPortfolio?.Portfolio) {
            const updatedArray = this.updatePortfolioMargins(
              this.userPortfolio.Portfolio.USDPortfolio.Portfolio,
              custodianSymbols
            );
            this.userPortfolio.Portfolio.USDPortfolio = {
              ...this.userPortfolio.Portfolio.USDPortfolio,
              Portfolio: updatedArray
            };
          }

          if (this.userPortfolio.Portfolio.RatedPortfolio?.Portfolio) {
            const updatedArray = this.updatePortfolioMargins(
              this.userPortfolio.Portfolio.RatedPortfolio.Portfolio,
              custodianSymbols
            );
            this.userPortfolio.Portfolio.RatedPortfolio = {
              ...this.userPortfolio.Portfolio.RatedPortfolio,
              Portfolio: updatedArray
            };
          }

          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error in margin update:', error);
        }
      });
  }


private updatePortfolioMargins(portfolio: PortfolioElement[], custodianSymbols: any[]): PortfolioElement[] {
  if (!portfolio || !custodianSymbols) {
    return portfolio;
  }

  return portfolio.map(portfolioItem => {
    const matchingSymbol = custodianSymbols.find(
      custodianSymbol => custodianSymbol.SymbolCode === portfolioItem.SymbolCode
    );

    if (matchingSymbol && matchingSymbol.MarginPercentage != null) {
      return { ...portfolioItem, MarginPercentage: matchingSymbol.MarginPercentage };
    }

    return portfolioItem;
  });
}

get filteredAccounts() {
  return this.accList?.filter(acc => acc.accountType !== 3 && acc.accountType !== 5);
}

}
